import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { cybersec2026Banner } from 'src/assets/images'
import AccentBox from 'src/components/PostGraduationContent/PostgraduateComponents/AccentBox/AccentBox'
import CustomTable from 'src/components/PostGraduationContent/PostgraduateComponents/Table/CustomTable'
import BreadcrumbsComponent from 'src/components/BreadcrumbsComponent/BreadcrumbsComponent'
import { useGlobalStyles } from 'src/mui/styles/globalStyles'
import { useStyles } from './PostGraduateResults2026.styles'

const PostGraduateResultsContent = () => {
  const { t } = useTranslation()
  const classes = useStyles()
  const globalClasses = useGlobalStyles()

  const data = [
    { name: 'CARLOS GABRIEL DOS SANTOS ALVES' },
    { name: 'HERON FELIPE COUTINHO GUERRA CORRÊA' },
    { name: 'GABRIEL PAIXÃO DE OLIVEIRA' },
    { name: 'FELIPE DA COSTA MARQUES' },
    { name: 'FRANCILDO FELIX DE MOURA' },
    { name: 'RYAN GUILHERME MORAIS NASCIMENTO' },
    { name: 'THYAGO CHRYSTIANN DA SILVA LOPES' },
    { name: 'AYALA RODRIGUES FREIRE' },
    { name: 'JOÃO VICTOR DA SILVA PINHEIRO' },
    { name: 'VALDANO CÁ' },
    { name: 'ALÍCIA MARIA GUALBERTO LIMA' },
    { name: 'ISIS NASCIMENTO DE LAVOR' }
  ]
  return (
    <Box className={globalClasses.containerPages}>
      <BreadcrumbsComponent
        crumbs={[
          { label: t('navbar.start'), path: '/' },
          { label: t('navbar.postgraduate'), path: '/postgraduate' },
          {
            label: 'Residência em Segurança Cibernética 2026',
            path: '/postgraduate/rsc-2026'
          },
          {
            label: t('news.postgraduate.sub.results.page-title')
          }
        ]}
      />
      <Box className={classes.container}>
        <Typography className={globalClasses.titleSectionVariant2}>
          {t('news.postgraduate.sub.results.page-title')}
        </Typography>
        <Box className={classes.contentWrapper}>
          <img
            className={classes.promoImg}
            src={cybersec2026Banner}
            alt="Banner"
          />
          <Box className={classes.contentContainer}>
            <Typography className={globalClasses.titleSectionVariant2}>
              Classificação do Processo Seletivo
            </Typography>
            <Typography className={classes.paragraph}>
              O Laboratório de Sistemas e Banco de Dados (LSBD) informa aos(às)
              candidatos(as) inscritos(as) no Edital nº 01/2026 – Seleção para a
              Residência em Segurança Cibernética (Turma 2026), ofertada pelo
              Departamento de Computação da Universidade Federal do Ceará, a
              divulgação do resultado final da segunda fase. Confira abaixo:
            </Typography>
            <Typography className={globalClasses.titleSectionVariant2}>
              {t('news.postgraduate.sub.results.table.title4')}
            </Typography>
            <Box className={classes.tableContainer}>
              <CustomTable
                headers={[t('news.postgraduate.sub.results.table.name')]}
                rows={data.map((person) => [person.name])}
              />
            </Box>
            <Box className={classes.separator} />
            <Typography className={globalClasses.titleSectionVariant2}>
              {t('news.postgraduate.sub.contact')}
            </Typography>
            <AccentBox email="rsc@lsbd.ufc.br" />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default PostGraduateResultsContent
